import React, { useState, useEffect } from 'react';

function Idletimer({ timeout, onIdle }) {
  const [isIdle, setIsIdle] = useState(false);

  let idleTimeout;

  const resetIdleTimer = () => {
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(setIsIdleTrue, timeout);
    setIsIdle(false);
  };

  const setIsIdleTrue = () => {
    setIsIdle(true);
    if (onIdle) {
      onIdle();
    }
  };

  useEffect(() => {
    resetIdleTimer();

    // Event listeners to reset the timer on user activity
    const events = ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'];

    const attachEventListeners = () => {
      events.forEach((event) => {
        window.addEventListener(event, resetIdleTimer, { passive: true });
      });
    };

    const detachEventListeners = () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetIdleTimer);
      });
    };

    // Attach event listeners
    attachEventListeners();

    // Clear the timer and remove event listeners when the component unmounts
    return () => {
      clearTimeout(idleTimeout);
      detachEventListeners();
    };
  }, [timeout, onIdle]);

  return (
   <></>
  );
}

export default Idletimer;